<template>
  <div class = "wrap-block" style="padding-top: 20px;">
  <p  style="color: #646a73; text-align: center;padding-bottom: 50px;">从业人员不得违规销售非保险金融产品,请勿参与非法集资</p>
    <div class = "content-block service-block">
      <div class = "service-block">
        <div class = "block-line"></div>
        <p class = "service-info-title">我们的产品和服务</p>
        <p class = "service-info-subtitle">服务至上，完美的客户服务感受体验</p>
        <div class = "service-list">
          <div class = "service-title" v-for = "(item,index) in serviceList" :key = "index">
            <div class = "is-hover-shadow">
              <div class = "service-title-shadow ">
                <img :src = "item.path" alt = "" style="width: 200px;height: 150px;">
              </div>
            </div>
            <p class = "service-name">{{ item.description }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class = "content-block service-idea">
      <div class = "service-idea">
        <div class = "idea-left">
          <img :src = "serviceIdeaImg[0].path" :alt = "serviceIdeaImg[0].name">
        </div>
        <div class = "idea-right">

          <p class = "idea-title">{{ serviceIdeaInfo.ideaTitle }}</p>
          <p class = "idea-subtitle">{{ serviceIdeaInfo.ideaSubtitle }}</p>
          <img :src = "serviceIdeaImg[1].path" :alt = "serviceIdeaImg[1].name" >
          <p class = "idea-desc">{{ serviceIdeaInfo.ideaDesc }}</p>
          <router-link :to = "{path:'/ours',query:{Index: '3'}}">
            <el-button type = "primary" round>加入我们</el-button>
          </router-link>
        </div>
      </div>
      <div class = "content-block service-case">
          <div class = "service-case">
            <div class = "block-line"></div>
            <p class = "case-title">五大赋能平台</p>
            <p class = "case-subtitle">保险+科技+服务</p>
            <div class = "case-list">
              <div class = "case-info" v-for = "(item, index) in energizeList" :key = "index">
                <el-card :body-style = "{ padding: '0px' }" shadow = "hover">
                  <img :src = "item.path" :alt = "item.desc" :style="imageStyle" style="padding-top: 40px;">
                </el-card>
                <el-progress :percentage = "50" :show-text = "false"></el-progress>
                <p class = "case-desc">{{ item.desc }}</p>
              </div>
            </div>
          </div>
      </div>
      <div class="cont">
            <div  style="margin-left: -10px; margin-right: -10px;">
              <div class="el-col el-col-6" style="padding-left: 10px; padding-right: 10px;">
                <div class="cont_b">
                <img src="../../assets/img/index/pc01.png" alt="">
                <h4 class="font_16">经验丰富</h4>
                <p class="cont_border"></p>
                <p class="cont_btn font_12">百余款网红产品尽收旗下</p>
                <p class="cont_btn font_12">产品库品种齐全性价比高</p>
              </div>
              </div>
              <div class="el-col el-col-6" style="padding-left: 10px; padding-right: 10px;">
                <div class="cont_b">
                  <img src="../../assets/img/index/pc02.png" alt="">
                  <h4 class="font_16">渠道多元</h4>
                  <p class="cont_border"></p>
                  <p class="cont_btn font_12">B端C端合作全面打通</p>
                  <p class="cont_btn font_12">1000+创业合伙平台携手同行</p>
              </div>
              </div>
              <div class="el-col el-col-6" style="padding-left: 10px; padding-right: 10px;">
                <div class="cont_b">
                  <img src="../../assets/img/index/pc03.png" alt="">
                  <h4 class="font_16">服务专业</h4>
                  <p class="cont_border"></p>
                  <p class="cont_btn font_12">丰富的实践经验</p>
                  <p class="cont_btn font_12">获得业界广大客户的好评</p>
              </div>
              </div>
                <div class="el-col el-col-6" style="padding-left: 10px; padding-right: 10px;">
                  <div class="cont_b">
                    <img src="../../assets/img/index/pc04.png" alt="">
                    <h4 class="font_16">科技加持</h4>
                    <p class="cont_border"></p>
                    <p class="cont_btn font_12">科技创新积极赋能</p>
                    <p class="cont_btn font_12">助您维度升级，服务更精准高效</p>
                  </div>
              </div>
            </div>
      </div>
    </div>
    <div class = "content-block service-case">
      <div class = "service-case">
        <div class = "block-line"></div>
        <p class = "case-title">五大生态</p>
        <p class = "case-subtitle">全场景数智保险服务商</p>
        <div class = "case-list">
          <div class = "case-info" v-for = "(item,index) in caseList" :key = "index">
            <el-card :body-style = "{ padding: '0px' }" shadow = "hover">
              <img :src = "item.path" :alt = "item.desc" :style="imageStyles">
            </el-card>
            <el-progress :percentage = "50" :show-text = "false"></el-progress>
            <p class = "case-desc">{{ item.desc }}</p>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'IndexService',
  data () {
    return {
      serviceList: [
        {
          description: '财产险',
          path: require('../../assets/img/index/03.png')
        },
        {
          description: '车险',
          path: require('../../assets/img/index/01.png')
        },
        {
          description: '寿险',
          path: require('../../assets/img/index/02.png')
        }
      ],
      serviceIdeaInfo:
        {
          ideaTitle: '经营模式',
          ideaSubtitle: '服务平台 + 创业平台',
          ideaDesc: '安澜经纪倡导把企业的围墙打开，将自己定位为平台型企业，开放给所有的保险经纪人团队。不再管理经纪人，而是服务经纪人。服务于市场上所有即将转型的经纪人/团队，或者为转型做准备的经纪人们。'
        },
      serviceIdeaImg: [
        {
          name: 'lefImg',
          path: require('../../assets/img/index/service1.png')
        },
        {
          name: 'rightImg',
          path: require('../../assets/img/index/service2.png')
        }
      ],
      caseList: [
        {
          desc: '出行生态',
          path: require('../../assets/img/index/st1.png')
        },
        {
          desc: '金融生态',
          path: require('../../assets/img/index/st2.png')
        },
        {
          desc: '人资生态',
          path: require('../../assets/img/index/st3.png')
        },
        {
          desc: 'G端生态',
          path: require('../../assets/img/index/st4.png')
        },
        {
          desc: '健康生态',
          path: require('../../assets/img/index/st5.png')
        }
      ],
      energizeList: [
        {
          desc: '身份赋能',
          path: require('../../assets/img/index/001.png')
        },
        {
          desc: '产品赋能',
          path: require('../../assets/img/index/002.png')
        },
        {
          desc: '政策赋能',
          path: require('../../assets/img/index/003.png')
        },
        {
          desc: '科技赋能',
          path: require('../../assets/img/index/004.png')
        },
        {
          desc: '服务赋能',
          path: require('../../assets/img/index/005.png')
        }
      ],
      imageStyle: {
        width: '50%', // 设置图片宽度为100像素
        height: '100%' // 高度自动调整保持图片比例
      },
      imageStyles: {
        width: '100%', // 设置图片宽度为100像素
        height: '100%' // 高度自动调整保持图片比例
      },
      percentage: '50'
    }
  }
}
</script>

<style lang = "less" scoped>

.cont {   height: 530px;
          text-align:center;
          padding: 100px 160px;
          background: rgba(243, 243, 243, 1)
        }

        .cont .cont_b {
            background: linear-gradient(225deg, rgba(138, 164, 245, 1) 0, rgba(82, 107, 231, 1) 100%);
            padding: 50px 20px;
            width: 100%;
            height: 330px;
            transition: all 1s;
            border-radius: 5%;

        }

        .cont  .cont_btn {
            color: rgba(248, 248, 248, 1);
        }

        .cont_b img {
            width: 80px;
            height: 80px;
            margin: auto;
            margin-bottom: .1rem;
        }

        .cont_b:hover {
            transform: scale(1.1);
        }

        .cont_btn {
            color: rgba(192, 196, 204, 1)
        }

        .cont_b .cont_border {
            width: 15px;
            height: 2px;
            margin: 2px auto;
            background: linear-gradient(225deg, rgba(138, 164, 245, 1) 0, rgb(255, 255, 255) 100%)
        }
.wrap-block {
  position: relative;

  .content-block {
    position: relative;
    //width: 100%;
    overflow: hidden;
  }
}

.service-block {
  max-width: 100%;
  height: 500px;
  margin: 0 auto;
  text-align: center;
  overflow-x: hidden;

  .block-line {
    margin: 0 auto 12px;
    width: 24px;
    height: 4px;
    background-color: #3370ff;
    border-radius: 100px;
  }

  .service-info-title {
    font-weight: 700;
    font-size: 32px;
    position: relative;
    bottom: 2px;
    //padding-top: 60px;
  }

  .service-info-subtitle {
    font-size: 16px;
    line-height: .5;
    color: #646a73;
    margin-top: 20px;
  }

  .service-list {
    display: flex;
    justify-content: space-evenly;
    text-align: center;
    //padding: 0 200px;
    margin: 70px auto 0 auto;
  }

  .service-title-shadow {
    width: 111px;
    height: 111px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: .3s;
  }

  .service-title-shadow:hover {
    width: 111px;
    height: 111px;
    border-radius: 50%;
    transform: scale(1.05) translateY(-1px);
    box-shadow: 0 6px 20px 0 rgba(0, 0, 0, .15);
  }

  .service-name {
    margin-top: 30px;
    font-weight: 600;
    font-size: 20px;
  }
}

.content-block.service-idea {
  background-color: rgba(242, 243, 244,1);
  width: 100%;

  .service-idea {
    max-width: 100%;
    //height: 700px;
    overflow: hidden;
    display: flex;
  }

  .idea-left img {
    width: 600px;
    height: 500px;
  }

  .idea-right {
    height: 500px;
    width: calc(100% - 100px);
    margin-left: 50px;
    padding-top: 50px;

    .block-line {
      margin: 0 0 12px 0;
      width: 24px;
      height: 4px;
      background-color: #3370ff;
      border-radius: 100px;
    }

    .idea-title {
      font-weight: 700;
      font-size: 32px;
      position: relative;
      bottom: 2px;
      //padding-top: 60px;
    }

    .idea-subtitle {
      font-size: 20px;
      line-height: .5;
      color: #646a73;
      margin-top: 10px;
    }

    img {
      width: 950px;
      height: 112px;
      object-fit: cover;
      margin-top: 10px;
    }

    .idea-desc {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 4;
      overflow: hidden;
      max-height: 88px;
      max-width: 800px;
      font-size: 16px;
      line-height: 30px;
      color: #646a73;
    }

    .el-button {
      margin-top: 40px;
    }
  }

}

.content-block.service-case {
  background-color: #FFFFFF;
  width: 100%;

  .service-case {
    max-width: 1440px;
    //height: 700px;
    overflow: hidden;
    margin: 0 auto;
    text-align: center;
    padding-top: 50px;

    .block-line {
      margin: 0 auto 12px;
      width: 24px;
      height: 4px;
      background-color: #3370ff;
      border-radius: 100px;
    }

    .case-title {
      font-weight: 700;
      font-size: 32px;
      position: relative;
      bottom: 2px;
      //padding-top: 60px;
    }

    .case-subtitle {
      font-size: 16px;
      line-height: .5;
      color: #646a73;
      margin-top: 10px;
    }

    .case-list {
      display: flex;
      justify-content: space-evenly;
    }

    .el-card {
      width: 247px;
      height: 217px;
      margin-top: 40px;
    }

    .el-progress {
      margin-top: 10px;
    }

    /deep/ .el-progress-bar__outer {
      height: 2px !important;
    }

    .case-desc {
      margin-top: 30px;
      margin-bottom: 60px;
      font-weight: 500;
      font-size: 16px;
    }
  }
}
</style>
